import React from "react";

import Images from "../../images";

const SubscriptionPage = () => (
  <div>
    <div
      style={{
        fontFamily: "Helvetica, sans-serif",
        fontSize: 20,
        background: "#fff",
        textRendering: "optimizeLegibility"
      }}
    >
      <div style={{ paddingTop: 50 }}>
        <div style={{ width: 260, margin: "0 auto" }}>
          <a
            href="/"
            style={{ display: "block", textDecoration: "none", outline: 0 }}
          >
            <img
              src={Images.logo}
              alt="Cliffhanger"
              style={{ width: "100%", maxWidth: "100%" }}
            />
          </a>
        </div>
      </div>
    </div>

    <div className="content page">
      <div className="hero">
        <div className="lockup">
          <div className="heading">
            <h1 className="title">Subscription Information</h1>
          </div>
        </div>
      </div>

      <p>CLIFFHANGER UNLIMITED SUBSCRIPTIONS: </p>

      <ul>
        <li>
          You can subscribe for unlimited access to entire Cliffhanger catalog
          for the duration of your subscription
        </li>
        <li>Cliffhanger offers weekly, monthly, and annual subscriptions</li>
        <li>Weekly subscriptions will be charged at $2.99/week*</li>
        <li>Monthly subscriptions will be charged at $7.99/month*</li>
        <li>Annual subscriptions will be charged at $39.99/year*</li>
        <li>
          Payment will be charged to iTunes Account at confirmation of purchase
        </li>
        <li>
          Subscription automatically renews unless auto-renew is turned off at
          least 24-hours before the end of the current period
        </li>
        <li>
          Account will be charged for renewal within 24-hours prior to the end
          of the current period
        </li>
        <li>
          Subscriptions may be managed by the user and auto-renewal may be
          turned off by going to the user’s Account Settings after purchase
        </li>
        <li>
          No cancellation of the current subscription is allowed during active
          subscription period
        </li>
        <li>
          Any unused portion of a free trial period, if offered, will be
          forfeited when the user purchases a subscription to that publication
        </li>
      </ul>

      <p>
        By using Cliffhanger, you agree to our Terms of Service (<a
          href={`${
            typeof window !== "undefined" ? window.location.origin : ""
          }/legal/terms/`}
        >
          https://cliffhangerinteractive.com/legal/terms/
        </a>) and Privacy Policy (<a
          href={`${
            typeof window !== "undefined" ? window.location.origin : ""
          }/legal/privacy/`}
        >
          https://cliffhangerinteractive.com/legal/privacy/
        </a>).
      </p>

      <p>
        *Prices are equal to the value that “Apple’s App Store Matrix”
        determines is the equivalent subscription price in $USD
      </p>
    </div>

    <div className="footer">
      <a href="/legal/copyright/">Copyright</a>
      <a href="/legal/privacy/">Privacy Policy</a>
      <a href="/legal/subscription/">Subscription</a>
      <a href="/legal/terms/">Terms of Service</a>
    </div>
  </div>
);

export default SubscriptionPage;



// WEBPACK FOOTER //
// ./src/pages/legal/subscription.js